import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 120px;
  box-sizing: border-box;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const InfoText = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
